const Backbone = require('backbone');
const Nunjucks = require('nunjucks');
const $ = require('jquery');


const MyLoader = Nunjucks.WebLoader.extend({
	fetch: function(url, cb) {
	    // Only in the browser please
	    if (typeof window === 'undefined') {
	      throw new Error('WebLoader can only by used in a browser');
	    }

	    var ajax = new XMLHttpRequest();
	    var loading = true;

	    ajax.onreadystatechange = function () {
	      if (ajax.readyState === 4 && loading) {
	        loading = false;

	        if (ajax.status === 0 || ajax.status === 200) {
	          cb(null, ajax.responseText);
	        } else {
	          cb({
	            status: ajax.status,
	            content: ajax.responseText
	          });
	        }
	      }
	    };

	    //url += (url.indexOf('?') === -1 ? '?' : '&') + 's=' + new Date().getTime();
	    
	    ajax.open('GET', url, this.async);
	    ajax.send();
	}
});

var env = new Nunjucks.Environment(new MyLoader('./views',{useCache:true,async:true}));

env.getTemplate('includes/footer.twig', true);
env.getTemplate('includes/logo.twig', true);
env.getTemplate('includes/menu.twig', true);
env.getTemplate('includes/header.twig', true);
env.getTemplate('layout.twig', true);
env.getTemplate('404/index.twig', true);
env.getTemplate('home/index.twig', true);
env.getTemplate('home/index.twig', true);

const DefaulfView = Backbone.View.extend({
	el: 'body',
	initialize: function(config) {
		var that = this;
		that.template = config.template;
		that.render();
	},
	events: {
		'click a[href]:not(.fancybox)': 'navigate',
	},
	navigate: function(e) {
		
		var that = this;
		var $el = that.$el.find(e.currentTarget);
		var href = $el.attr('href');

		if (/^(javascript\:|mailto\:|callto\:|tel\:|_|http[s]?)/.test(href)) {
			return true;
		}
		e.stopPropagation();
		e.preventDefault();

		Backbone.history.navigate(href,{trigger:true});
		return false;
	},
	render404: function(e) {
		env.render('404/index.twig', data, function(e, html) {
			if (e) {
				console.log(e);
				return;
			}
			that.$el.html(html);
		});

	},
	render: function() {
		var that = this;

		var data = that.model.toJSON();
		env.render(that.template, data, function(err, html) {

			if (err) {
				that.render404(err);
			}

			that.$el.html(html);
			
			window.setTimeout(function() {
				//that.$el.find('.fancybox').fancybox();
				$('.carousel').slick();
			});

		});
	}
});

module.exports = DefaulfView;



//////////////////
// WEBPACK FOOTER
// ./js/views/default.js
// module id = 15
// module chunks = 0